import React from 'react'
import withStyles from '@mui/styles/withStyles'
import ProgressIndicator from 'components/molecules/progressIndicator'
import QAPVars from 'qap/vars'

type Props = {
  classes: any;
  children?: string;
};

const styles = (theme: any) => ({
  loading: {
    color: QAPVars.pGLight,
    fontWeight: 'normal',
    margin: theme.spacing(2, 0),
    display: 'inline-flex'
  },

  progressIndicator: {
    marginLeft: 8
  },
})

const LoadingMessage = ({
  classes,
  children,
}: Props) => (
  <h4 className={classes.loading}>
    {children || 'Loading'}
{ /* @ts-expect-error - TS2322 - Type '{ size: number; show: true; className: any; }' is not assignable to type 'IntrinsicAttributes & Props'. */}
    <ProgressIndicator size={20} show className={classes.progressIndicator} />
  </h4>
)

export default withStyles(styles)(LoadingMessage)
